import { User } from "./user";
import { Group } from "../index";
import { PatientThreshold } from "./patient-threshold";

export class Patient {

    id: string;
    firstName: string;
    middleInitial: string;
    lastName: string;
    title: string;
    phoneNumber: string;
    cell: string;
    email: string;
    description: string;
    timezone: string;
    dst: boolean;
    isDeleted: boolean;
    facilityId: string;
    comment: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    isApproved: boolean;
    isLockedOut: boolean;
    ssn: string;
    dob: any;
    sex: string;
    picture: string;
    groupId: string;
    weight: string;
    room: string;
    emrresidentId: string;
    height: string;
    floor: string ;
    bed: string ;
    emrclientId: string;
    user: User;
    patientAdmission: any;
    patientAllergy: any;
    patientCategoryHistory: any;
    patientDiagnosis: any;
    patientImage: any;
    patientPharmacy: any;
    patientPhysician: any;
    patientSmartReportSettings: any;
    patientSurgery: any;
    patientThresholds : PatientThreshold[];
    group: Group;
    base64Image: any;
    hasImage: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/patient.ts